import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
// Add your imports here
import LoanCalculatorDashboard from "pages/loan-calculator-dashboard";
import SettingsConfiguration from "pages/settings-configuration";
import PrintPreviewReport from "pages/print-preview-report";
import NotFound from "pages/NotFound";

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          {/* Define your routes here */}
          <Route path="/" element={<LoanCalculatorDashboard />} />
          <Route path="/loan-calculator-dashboard" element={<LoanCalculatorDashboard />} />
          <Route path="/settings-configuration" element={<SettingsConfiguration />} />
          <Route path="/print-preview-report" element={<PrintPreviewReport />} />
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;